import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';
import ContadorCalendario from '@mui/material/Badge';
import IconoCalendario from '@mui/icons-material/EventAvailableRounded';
import MenuIcon from '@mui/icons-material/Menu';
import { FaBell, FaCalendarCheck } from 'react-icons/fa';
import { FaUserMd } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaTachometerAlt } from 'react-icons/fa';
import { FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../context/authContext';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { obtenerNotificacionesDeBD } from '../../service/notificacionService';


const Navbar = ({ carrito = [] }) => {
  const navigate = useNavigate();
   const location = useLocation();
  const cantTurnos = carrito.length;
  const [mostrarCartelito, setMostrarCartelito] = useState(false);
  const [yaSeMostro, setYaSeMostro] = useState(false);
  const [hayNoLeidas, setHayNoLeidas] = useState(true);
  const [menuAbierto, setMenuAbierto] = useState(false);
  

  const [modalLogoutAbierto, setModalLogoutAbierto] = useState(false);

  const { usuario, tieneRol, logout } = useAuth();
  const userId = usuario?.pacienteId || usuario?.medicoId || usuario?._id;


  useEffect(() => {

    if (!userId) return;

    const revisarNotificaciones = async () => {
      try {
        const datos = await obtenerNotificacionesDeBD(userId);
        
        const tienePendientes = datos.some(notif => !notif.leida);
        setHayNoLeidas(tienePendientes);
      } catch (error) {
        console.error("Error al buscar el estado de notificaciones para el Navbar:", error);
      }
    };
    revisarNotificaciones();
  }, [userId]);

  // SOLO QUIERO MOSTRAR EL CARTELITO UNA SOLA VEZ
  useEffect(() => {
    if (cantTurnos === 1 && !yaSeMostro) {
      setMostrarCartelito(true);
      setYaSeMostro(true);

      const timer = setTimeout(() => {
        setMostrarCartelito(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [cantTurnos, yaSeMostro]);

  const irACheckout = () => {
    setMostrarCartelito(false);
    setMenuAbierto(false);
    navigate('/resumen');
  };

  const irAConfigMedico = () => {
    setMenuAbierto(false);
    navigate('/serviciosMedico');
  };

  const irAMisTurnos = () => {
    setMenuAbierto(false);
    navigate('/turnos');
  }

  const irADashboardTurnos = () => {
    setMenuAbierto(false);
    navigate('/dashboard-turnos');
  };

  const irANotificaciones = () => {
    setMenuAbierto(false);
    navigate('/notificaciones');
  };

  const irAInicio = () => {
    if (tieneRol(["MEDICO"])) {
      navigate("/dashboard-turnos");
    } else {
      navigate("/");
    }

    setMenuAbierto(false);
  };


  const handleLogoutClick = () => {
    setModalLogoutAbierto(true);
    setMenuAbierto(false);
  };


  const confirmarLogout = () => {
    logout();
    setModalLogoutAbierto(false);
    navigate('/');
  };


  const cancelarLogout = () => {
    setModalLogoutAbierto(false);
  };

  const getInitial = () => {
    if (!usuario?.nombre) return '?';
    return usuario.nombre.charAt(0).toUpperCase();
  };
  
  const getRolText = () => {
    if (!usuario?.rol) return '';
    const roles = {
      'PACIENTE': 'Paciente',
      'MEDICO': 'Médico'
    };
    return roles[usuario.rol] || usuario.rol;
  };

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  return (
    <header className="navbar-bg">
      <nav className="navbar">
        <div className="navbar-section left">
          <button className="menu-icon" onClick={toggleMenu}>
            <MenuIcon />
          </button>
        </div>

        <div className="navbar-section center">
          <div className="brand">
            <h1
              className="brand-text"
              onClick={irAInicio}
              style={{ cursor: "pointer" }}
            >
              Sweet Medical
            </h1>
          </div>
        </div>

        <div className="navbar-section right">
          
          {usuario ? (
            <div className="user-avatar-small" title={`${usuario?.nombre} - ${getRolText()}`}>
              {getInitial()}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="auth-btn login-btn">Iniciar sesión</Link>
              <Link to="/registro" className="auth-btn register-btn">Registrarse</Link>
            </div>
          )}
        
          {usuario && (
            <Link to={'/notificaciones'} className="nav-notif-btn" title="Notificaciones">
              <FaBell size={22} />
              {hayNoLeidas && <span className="notification-dot"></span>}
            </Link>
          )}

          {usuario && tieneRol(['MEDICO']) && (
            <button className="nav-notif-btn" onClick={irAConfigMedico} title="Configuración médica">
              <FaUserMd size={22} color="#D50032" />
            </button>
          )}

          {usuario && tieneRol(['PACIENTE']) && (
            <button className="nav-notif-btn" onClick={irAMisTurnos} title="Mis turnos agendados">
              <FaCalendarAlt size={20} color="#D50032" />
            </button>
          )}

          {usuario && tieneRol(['MEDICO']) && (
            <button
              className="nav-notif-btn"
              onClick={irADashboardTurnos}
              title="Dashboard Compartido"
            >
              <FaTachometerAlt size={20} color="#D50032" />
            </button>
          )}

          {usuario && tieneRol(['PACIENTE']) && (
            <button className="cart-button" onClick={irACheckout}>
              <ContadorCalendario badgeContent={cantTurnos} color="primary" max={99}>
                <IconoCalendario fontSize="large" />
              </ContadorCalendario>
              <span>Turnos Seleccionados</span>
            </button>
          )}

          {usuario && (
            <button 
              className="nav-notif-btn" 
              onClick={handleLogoutClick} 
              title="Cerrar sesión"
              style={{ marginLeft: '8px' }}
            >
              <FaSignOutAlt size={20} color="#D50032" />
            </button>
          )}
          
          {mostrarCartelito && (
            <div className="cartelito-animado" onClick={irACheckout}>
              ¡Turno agregado! Clic acá para ver tu preselección.
            </div>
          )}

        </div>

        <div className={`mobile-menu ${menuAbierto ? 'open' : ''}`}>
          {usuario ? (
            <>
              <div className="mobile-user-info">
                <div className="mobile-user-avatar">{getInitial()}</div>
                <div className="mobile-user-details">
                  <span className="mobile-user-name">{usuario?.nombre || 'Usuario'}</span>
                  <span className="mobile-user-rol">{getRolText()}</span>
                </div>
              </div>

              <div className="mobile-menu-divider"></div>

              {tieneRol(['PACIENTE']) && (
                <button className="mobile-menu-item" onClick={irAMisTurnos}>
                  <div className="mobile-icon-wrapper">
                    <FaCalendarCheck size={20} />
                  </div>
                  Mis Turnos Agendados
                </button>
              )}

              <button className="mobile-menu-item" onClick={irANotificaciones}>
                <div className="mobile-icon-wrapper">
                  <FaBell size={20} />
                  {hayNoLeidas && <span className="notification-dot-mobile"></span>}
                </div>
                Notificaciones
              </button>

              {tieneRol(['MEDICO']) && (
                <button className="mobile-menu-item" onClick={irAConfigMedico}>
                  <div className="mobile-icon-wrapper">
                    <FaUserMd size={20} />
                  </div>
                  Configuración médica
                </button>
              )}

              {tieneRol(['MEDICO']) && (
                <button className="mobile-menu-item" onClick={irADashboardTurnos}>
                  <div className="mobile-icon-wrapper">
                    <FaTachometerAlt size={20} />
                  </div>
                  Dashboard Compartido
                </button>
              )}

              {tieneRol(['PACIENTE']) && (
                <button className="mobile-menu-item" onClick={irACheckout}>
                  <div className="mobile-icon-wrapper">
                    <ContadorCalendario badgeContent={cantTurnos} color="primary" max={99}>
                      <IconoCalendario fontSize="small" />
                    </ContadorCalendario>
                  </div>
                  Turnos Seleccionados
                </button>
              )}

              <button className="mobile-menu-item" onClick={handleLogoutClick} style={{ borderTop: '1px solid #eee' }}>
                <div className="mobile-icon-wrapper">
                  <FaSignOutAlt size={20} color="#D50032" />
                </div>
                Cerrar sesión
              </button>
            </>
          ) : (
            <>
              <div className="mobile-user-info">
                <div className="mobile-user-avatar" style={{ backgroundColor: '#ccc' }}>?</div>
                <div className="mobile-user-details">
                  <span className="mobile-user-name">No has iniciado sesión</span>
                </div>
              </div>

              <div className="mobile-menu-divider"></div>

              <Link to="/login" className="mobile-menu-item" style={{ color: '#D50032', fontWeight: 'bold' }}>
                Iniciar sesión
              </Link>

              <Link to="/registro" className="mobile-menu-item">
                Registrarse
              </Link>
            </>
          )}
        </div>

      </nav>

      <Dialog
        open={modalLogoutAbierto}
        onClose={cancelarLogout}
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 1,
            maxWidth: '400px'
          }
        }}
      >
        <DialogTitle sx={{ 
          color: '#D50032', 
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <FaSignOutAlt size={20} color="#D50032" />
          Cerrar sesión
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: '1rem', color: '#363636' }}>
            ¿Estás seguro de que querés cerrar sesión?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
          <Button 
            onClick={cancelarLogout} 
            variant="outlined"
            sx={{ 
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Cancelar
          </Button>
          <Button 
            onClick={confirmarLogout} 
            variant="contained" 
            color="error"
            sx={{ 
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Sí, cerrar sesión
          </Button>
        </DialogActions>
      </Dialog>
    </header>
  );
};

export default Navbar;